module.exports = __webpack_public_path__ + "e53302958d6f160aa8bf93355db5ff82.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/landing/doc.jpeg
// module id = 1078
// module chunks = 0